import { setPositionX, setPositionY } from "../helpers";

export class DrawingScroll {
    
	constructor(canvas) {
		this.canvas = canvas;
		this.canvas.on({ "mouse:wheel": this._mouseWheelHandler.bind(this) });
	}
    
	_mouseWheelHandler(opt) {
		if (opt.e.ctrlKey === false) {
			const deltaX = opt.e.deltaX;
			const deltaY = opt.e.deltaY;
            
			setPositionX(this.canvas, deltaX / 2);
			setPositionY(this.canvas, deltaY / 2);
			
			opt.e.preventDefault();
			opt.e.stopPropagation();
		}
	}
}
